import React, { useState, useEffect } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageResize from 'quill-image-resize-module-react';

Quill.register('modules/imageResize', ImageResize);

const Editor = ({ initialValue, onChange }) => {
  const [editorHtml, setEditorHtml] = useState(initialValue || '');

  useEffect(() => {
    setEditorHtml(initialValue || '');
  }, [initialValue]);

  const handleChange = (html) => {
    setEditorHtml(html||'');
    if (onChange) {
      onChange(html||'');
    }
  };

  return (
    <div>
      <h6>Evidence</h6>
      <ReactQuill
        theme="snow"
        onChange={handleChange}
        value={editorHtml}
        modules={Editor.modules}
        formats={Editor.formats}
        bounds={'.app'}
      />
    </div>
  );
};

Editor.modules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'blockquote'],
    ['image'],
  ],
  clipboard: {
    matchVisual: false,
  },
  imageResize: {
    parchment: Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize'],
  },
};

Editor.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'image',
];

export default Editor;
